export const KraftPouch = ({ product, size = "md" }) => {
  const dims =
    size === "lg"
      ? "w-64 sm:w-72"
      : size === "sm"
      ? "w-40"
      : "w-56";

  return (
    <div className={`kraft-pouch ${dims} aspect-[3/4] mx-auto flex items-center justify-center p-3 sm:p-4`} data-testid={`pouch-${product.slug}`}>
      <div className="relative w-full h-full bg-[#FAF6EE] rounded-sm shadow-inner overflow-hidden flex items-center justify-center">
        <img
          src={product.label}
          alt={`${product.name} label`}
          className="w-full h-full object-contain p-1"
          loading="lazy"
        />
      </div>
    </div>
  );
};
